// copied from packages/ui/src/components/FlavorFinder/components/Results/index.ts
export * from "./FlavorFinderResults";
